
export class User {
  public id: number;
  public firstName: string;
  public lastName: string;
  public username: string;
  public password: string;
  public group: any;
  public phoneNumber: string;
}